import {
  ZCS_PTC_REFERRER_DIRECT,
  ZCS_PTC_REFERRER_DOMAIN_SET,
  ZCS_PTC_REFERRER_INTERNAL,
  ZCS_PTC_REFERRER_OTHER,
  ZCS_PTC_REFERRER_SELF_DOMAINS
} from 'constants/ptc';

export interface ReferrerClassification {
  /** Canonical domain used for both the forwarded header and cache key. */
  keyValue: string | undefined;
  /** Telemetry-only class. */
  referrerClass: string;
}

// Keep this classifier aligned with Kratos @mweb/services/src/ptc/referrer.ts.
export const classifyReferrer = (rawReferrer: string | undefined): ReferrerClassification => {
  const raw = rawReferrer?.trim();
  if (!raw) {
    return { keyValue: undefined, referrerClass: ZCS_PTC_REFERRER_DIRECT };
  }
  let host: string;
  try {
    host = new URL(raw).hostname || raw;
  } catch {
    host = raw;
  }
  host = host.toLowerCase().replace(/\.$/, '');
  // Configured domains have two labels; unlisted multi-part suffixes remain `other`.
  const labels = host.split('.');
  const registrable = labels.length > 2 ? labels.slice(-2).join('.') : host;
  if (ZCS_PTC_REFERRER_SELF_DOMAINS.has(registrable)) {
    return { keyValue: undefined, referrerClass: ZCS_PTC_REFERRER_INTERNAL };
  }
  if (ZCS_PTC_REFERRER_DOMAIN_SET.has(registrable)) {
    return { keyValue: registrable, referrerClass: registrable };
  }
  return { keyValue: undefined, referrerClass: ZCS_PTC_REFERRER_OTHER };
};
